import * as React from 'react';

import {Avatar} from '../avatar/avatar';
import {colors} from '../colors/colors';
import {LeadIconChevron} from '../icon/svg/lead-icon-chevron';

import styles from './lead-avatar.module.css';

type LoadingProps = {
    isLoading: true;
    includeNumber?: boolean;
};

type LoadedProps = {
    isLoading?: false;
    avatarUrl: string;
    leadNumber?: number | null | undefined;
};

type Props = LoadedProps | LoadingProps;

export function LeadAvatar(props: Props) {
    if (props.isLoading) {
        return (
            <div className={styles.avatar}>
                <LeadIconChevron
                    wrapWithDiv={false}
                    size={props.includeNumber ? 24 : 32}
                    // @ts-expect-error
                    fill={colors.offWhiteDk}
                />
                {props.includeNumber ? <div className={styles.number} /> : null}
            </div>
        );
    }

    return (
        <div className={styles.avatar}>
            <Avatar type='leads' avatarUrl={props.avatarUrl} size={props.leadNumber ? 24 : 32} />
            {props.leadNumber ? <span className={styles.number}>{props.leadNumber}</span> : null}
        </div>
    );
}
